import { Injectable } from "@angular/core";
import { AngularFireAuth } from "angularfire2/auth";
import firebase from "firebase";
import { LoadingController, AlertController } from "ionic-angular";
import * as moment from "moment";
import { Subscription } from "rxjs/Subscription";
import { ToastProvider } from "../toast/toast";
import { Storage } from "@ionic/storage";
import { Environment } from "../../environment/environment";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument
} from "angularfire2/firestore";
import { User } from "../../models/interfaces/user.interface";
import { Observable } from "rxjs/Observable";
import { Block } from "../../models/block.interface";
import { FirestoreProvider } from "../firestore/firestore";
import { AngularFireList, AngularFireDatabase } from "angularfire2/database";
import CryptoJS from "crypto-js";

/*
  Generated class for the UserProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class UserProvider {
  myDate = moment().format();
  private authSubscription: Subscription;
  blockchainRef: AngularFireList<Block[]>;
  firedata = firebase.database().ref("/users");
  keys: any;
  constructor(
    public loadingCtrl: LoadingController,
    public toast: ToastProvider,
    public afireauth: AngularFireAuth,
    public storage: Storage,
    public alertCtrl: AlertController,
    public afs: AngularFirestore,
    public firestore: FirestoreProvider,
    private database: AngularFireDatabase
  ) {}

  adduser(newuser) {
    const loading = this.loadingCtrl.create({
      spinner: "crescent",
      content: "Registering..."
    });
    loading.present();
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth
        .createUserWithEmailAndPassword(newuser.email, newuser.password)
        .then(() => {
          this.afireauth.auth.currentUser
            .updateProfile({
              displayName: newuser.displayName,
              photoURL:
                "https://firebasestorage.googleapis.com/v0/b/native-chain.appspot.com/o/defaultprofile.png?alt=media&token=455eb1c6-b3b6-4a16-94d7-8404517c77c7"
            })
            .then(() => {
              let myCode = Math.random()
                .toString(36)
                .substring(7);
              this.isUniqueCode(myCode).then((res: any) => {
                if (!res) {
                  let myCode = Math.random()
                    .toString(36)
                    .substring(7);
                  this.isUniqueCode(myCode).then((res: any) => {
                    if (!res) {
                      let myCode = Math.random()
                        .toString(36)
                        .substring(7);
                    }
                  });
                }
              });
              let usedCode = "None";
              if (newuser.referral != "") {
                usedCode = newuser.referral;
                this.rewardReferrer(
                  usedCode,
                  this.afireauth.auth.currentUser.uid
                ).then((res: any) => {});
              }
              this.firedata
                .child(this.afireauth.auth.currentUser.uid)
                .set({
                  uid: this.afireauth.auth.currentUser.uid,
                  displayName: newuser.displayName,
                  email: newuser.email,
                  referralCode: myCode
                })
                .then(() => {
                  loading.dismiss();
                  resolve({ success: true });
                })
                .catch(err => {
                  loading.dismiss();
                  this.toast.show(err.message);
                  reject(err);
                });

              const data: User = {
                uid: this.afireauth.auth.currentUser.uid,
                displayName: newuser.displayName,
                email: newuser.email,
                dateJoined: new Date(this.myDate),
                lastOnline: new Date(this.myDate),
                isOnline: true,
                verifiedManufacturer: false,
                appliedForVerification: false,
                scannedBlocks: ["First"],
                addedBlocks: ["First"],
                cell: newuser.cell,
                scannedItemCount: 0,
                addedItemCount: 0,
                transactions: ["0"],
                photoURL:
                  "https://firebasestorage.googleapis.com/v0/b/native-chain.appspot.com/o/defaultprofile.png?alt=media&token=455eb1c6-b3b6-4a16-94d7-8404517c77c7",
                ethAddress: newuser.address,
                referralCode: myCode,
                referrals: ["None"],
                referralPoints: newuser.points,
                referralCodeUsed: usedCode
              };

              const userAfsRef: AngularFirestoreDocument<User> = this.afs.doc(
                `users/${this.afireauth.auth.currentUser.uid}`
              );

              //firestore
              userAfsRef
                .set(data)
                .then(() => {
                  loading.dismiss();
                  resolve({ success: true });
                })
                .catch(err => {
                  loading.dismiss();
                  this.toast.show(err.message);
                  reject(err);
                });
            })
            .catch(err => {
              loading.dismiss();
              this.toast.show(err.message);
              reject(err);
            });
        })
        .catch(err => {
          loading.dismiss();
          this.toast.show(err.message);
          reject(err);
        });
    });
    return promise;
  }

  //checks if the referral code exists
  isUniqueCode(code) {
    var promise = new Promise((resolve, reject) => {
      this.firedata
        .orderByChild("uid")
        .once("value", snapshot => {
          let userdata = snapshot.val();
          let temparr = [];
          for (var key in userdata) {
            temparr.push(userdata[key]);
          }
          let unique = true;
          for (let x = 0; x < temparr.length; x++) {
            if (code == temparr[x].referralCode) {
              unique = false;
            }
          }
          resolve(unique);
        })
        .catch(err => {
          this.toast.show(err.message);
          reject(err);
        });
    });
    return promise;
  }

  rewardReferrer(code, myUID) {
    var promise = new Promise((resolve, reject) => {
      this.firedata
        .orderByChild("uid")
        .once("value", snapshot => {
          let userdata = snapshot.val();
          let userID;
          for (var key in userdata) {
            if (code == userdata[key].referralCode) userID = userdata[key].uid;
          }
          this.getspecificuser(userID).then((res: any) => {
            let referrals = res.referrals;
            let points = res.referralPoints;
            points += 50;
            if (referrals[0] == "None") {
              referrals.pop();
            }
            referrals.push(myUID);
            const userAfsRef: AngularFirestoreDocument<User> = this.afs.doc(
              `users/${userID}`
            );
            userAfsRef
              .update({
                referrals: referrals,
                referralPoints: points
              })
              .then(() => {
                resolve(true);
              })
              .catch(err => {
                this.toast.show(err.message);
                reject(err);
              });
          });
        })
        .catch(err => {
          this.toast.show(err.message);
          reject(err);
        });
    });
    return promise;
  }

  passwordreset(email) {
    const loading = this.loadingCtrl.create({
      spinner: "crescent",
      content: "Sending Email..."
    });
    loading.present();

    var promise = new Promise((resolve, reject) => {
      firebase
        .auth()
        .sendPasswordResetEmail(email)
        .then(() => {
          loading.dismiss();
          resolve({ success: true });
        })
        .catch(err => {
          loading.dismiss();
          reject(err);
          this.toast.show(err.message);
        });
    });
    return promise;
  }

  updateIsOnline(status) {
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.currentUser
        .updateProfile({
          displayName: this.afireauth.auth.currentUser.displayName,
          photoURL: this.afireauth.auth.currentUser.photoURL
        })
        .then(() => {
          const userAfsRef: AngularFirestoreDocument<User> = this.afs.doc(
            `users/${this.afireauth.auth.currentUser.uid}`
          );
          //firestore
          userAfsRef
            .update({
              isOnline: status,
              lastOnline: new Date(this.myDate)
            })
            .then(() => {
              resolve({ success: true });
            })
            .catch(err => {
              this.toast.show(err.message);
              reject(err);
            });
        })
        .catch(err => {
          this.toast.show(err.message);

          reject(err);
        });
    });
    return promise;
  }

  addTransaction(user, block) {
    if (user.transactions[0] == "0") {
      user.transactions.pop();
    }
    let transactionHash = CryptoJS.SHA256(moment().format() + user).toString(
      CryptoJS.enc.Hex
    );
    user.transactions.push(
      moment().format() +
        ". " +
        "Add Item: " +
        block.count +
        ". Transaction Hash: " +
        transactionHash
    );
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.currentUser
        .updateProfile({
          displayName: this.afireauth.auth.currentUser.displayName,
          photoURL: this.afireauth.auth.currentUser.photoURL
        })
        .then(() => {
          const userAfsRef: AngularFirestoreDocument<User> = this.afs.doc(
            `users/${this.afireauth.auth.currentUser.uid}`
          );
          //firestore
          userAfsRef
            .update({
              transactions: user.transactions
            })
            .then(() => {
              resolve({ success: true });
            })
            .catch(err => {
              this.toast.show(err.message);
              reject(err);
            });
        })
        .catch(err => {
          this.toast.show(err.message);

          reject(err);
        });
    });
    return promise;
  }

  scanTransaction(user, block) {
    if (user.transactions[0] == "0") {
      user.transactions.pop();
    }
    let transactionHash = CryptoJS.SHA256(moment().format() + user).toString(
      CryptoJS.enc.Hex
    );
    user.transactions.push(
      moment().format() +
        ". " +
        "Scan Block: " +
        block.count +
        ". Transaction Hash: " +
        transactionHash
    );
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.currentUser
        .updateProfile({
          displayName: this.afireauth.auth.currentUser.displayName,
          photoURL: this.afireauth.auth.currentUser.photoURL
        })
        .then(() => {
          const userAfsRef: AngularFirestoreDocument<User> = this.afs.doc(
            `users/${this.afireauth.auth.currentUser.uid}`
          );
          //firestore
          userAfsRef
            .update({
              transactions: user.transactions
            })
            .then(() => {
              resolve({ success: true });
            })
            .catch(err => {
              this.toast.show(err.message);
              reject(err);
            });
        })
        .catch(err => {
          this.toast.show(err.message);

          reject(err);
        });
    });
    return promise;
  }

  updateimage(imageurl) {
    const loading = this.loadingCtrl.create({
      spinner: "crescent",
      content: "Uploading Image..."
    });
    loading.present();
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.currentUser
        .updateProfile({
          displayName: this.afireauth.auth.currentUser.displayName,
          photoURL: imageurl
        })
        .then(() => {
          // firebase
          //   .database()
          //   .ref("/users/" + firebase.auth().currentUser.uid)
          //   .update({
          //     displayName: this.afireauth.auth.currentUser.displayName,
          //     photoURL: imageurl,
          //     uid: firebase.auth().currentUser.uid
          //   })
          //   .then(() => {
          //     loading.dismiss();
          //     resolve({ success: true });
          //   })
          //   .catch(err => {
          //     loading.dismiss();
          //     reject(err);
          //     this.toast.show(err.message);
          //   });

          const userAfsRef: AngularFirestoreDocument<User> = this.afs.doc(
            `users/${this.afireauth.auth.currentUser.uid}`
          );

          //firestore
          userAfsRef
            .update({ photoURL: imageurl })
            .then(() => {
              loading.dismiss();
              resolve({ success: true });
            })
            .catch(err => {
              loading.dismiss();
              this.toast.show(err.message);
              resolve({ success: false });
              reject(err);
            });
        })
        .catch(err => {
          loading.dismiss();
          reject(err);
          this.toast.show(err.message);
        });
    });
    return promise;
  }

  getuserdetails() {
    var promise = new Promise((resolve, reject) => {
      this.afs
        .doc(`users/${this.afireauth.auth.currentUser.uid}`)
        .valueChanges()
        .subscribe((user: User) => {
          resolve(user);
        });
      // this.firedata
      //   .child(firebase.auth().currentUser.uid)
      //   .once("value", snapshot => {
      //     resolve(snapshot.val());
      //   })
      //   .catch(err => {
      //     this.toast.show(err.message);
      //     reject(err);
      //   });
    });
    return promise;
  }

  updatedisplayname(newname) {
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.currentUser
        .updateProfile({
          displayName: newname,
          photoURL: this.afireauth.auth.currentUser.photoURL
        })
        .then(() => {
          this.firedata
            .child(firebase.auth().currentUser.uid)
            .update({
              displayName: newname,
              photoURL: this.afireauth.auth.currentUser.photoURL,
              uid: this.afireauth.auth.currentUser.uid
            })
            .then(() => {
              resolve({ success: true });
            })
            .catch(err => {
              this.toast.show(err.message);
              reject(err);
            });
        })
        .catch(err => {
          this.toast.show(err.message);
          reject(err);
        });
    });
    return promise;
  }

  updatetheme(color) {
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.currentUser
        .updateProfile({
          displayName: this.afireauth.auth.currentUser.displayName,
          photoURL: this.afireauth.auth.currentUser.photoURL
        })
        .then(() => {
          this.firedata
            .child(firebase.auth().currentUser.uid)
            .update({
              theme: color,
              photoURL: this.afireauth.auth.currentUser.photoURL,
              uid: this.afireauth.auth.currentUser.uid
            })
            .then(() => {
              resolve({ success: true });
              this.toast.show("Theme Changed!");
            })
            .catch(err => {
              this.toast.show(err.message);

              reject(err);
            });
        })
        .catch(err => {
          this.toast.show(err.message);

          reject(err);
        });
    });
    return promise;
  }

  updateVerification() {
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.currentUser
        .updateProfile({
          displayName: this.afireauth.auth.currentUser.displayName,
          photoURL: this.afireauth.auth.currentUser.photoURL
        })
        .then(() => {
          const userAfsRef: AngularFirestoreDocument<User> = this.afs.doc(
            `users/${this.afireauth.auth.currentUser.uid}`
          );

          let verified = false;
          if (Environment.isTestnet) {
            verified = true;
          }
          userAfsRef
            .update({
              appliedForVerification: true,
              verifiedManufacturer: verified
            })
            .then(() => {
              resolve({ success: true });
              this.toast.show("Application Sent!");
            })
            .catch(err => {
              this.toast.show(err.message);
              reject(err);
            });
          if (Environment.isTestnet) {
            let userRef$ = firebase
              .database()
              .ref(
                `/users/${this.afireauth.auth.currentUser.uid}/pro-membership`
              );
            userRef$
              .update({ status: "active" })
              .then(() => {
                resolve({ success: true });
                this.toast.show("Application Sent!");
              })
              .catch(err => {
                this.toast.show(err.message);
                reject(err);
              });
          }
        })
        .catch(err => {
          this.toast.show(err.message);

          reject(err);
        });
    });
    return promise;
  }

  updateScanCount(count, blocks) {
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.currentUser
        .updateProfile({
          displayName: this.afireauth.auth.currentUser.displayName,
          photoURL: this.afireauth.auth.currentUser.photoURL
        })
        .then(() => {
          const scanRef = this.afs.collection(
            `users/${this.afireauth.auth.currentUser.uid}/scannedUsers`
          );
          let nullData = {
            uid: 0,
            itemName: "",
            name: ""
          };
          scanRef
            .doc("users")
            .set(nullData)
            .then(() => {
              const userAfsRef: AngularFirestoreDocument<User> = this.afs.doc(
                `users/${this.afireauth.auth.currentUser.uid}`
              );
              //firestore
              userAfsRef.update({
                scannedItemCount: count,
                scannedBlocks: blocks
              });

              let lastBlock = blocks[blocks.length - 1];
              let uid = lastBlock.users[lastBlock.users.length - 2];
              let name = "";
              this.getspecificuser(
                lastBlock.users[lastBlock.users.length - 1]
              ).then((res: any) => {
                name =
                  res.displayName.slice(0, res.displayName.indexOf(" ") + 2) +
                  ".";
                let itemName: string;
                if (lastBlock.name != "") {
                  itemName = lastBlock.name;
                } else {
                  itemName = "Your item";
                }
                let data = {
                  uid: uid,
                  itemName: itemName,
                  name: name
                };
                scanRef.doc("users").set(data);
              });
            });
        })
        .catch(err => {
          this.toast.show(err.message);

          reject(err);
        });
    });
    return promise;
  }

  updateAddCount(count, blocks) {
    var promise = new Promise((resolve, reject) => {
      this.afireauth.auth.currentUser
        .updateProfile({
          displayName: this.afireauth.auth.currentUser.displayName,
          photoURL: this.afireauth.auth.currentUser.photoURL
        })
        .then(() => {
          const userAfsRef: AngularFirestoreDocument<User> = this.afs.doc(
            `users/${this.afireauth.auth.currentUser.uid}`
          );
          //firestore
          userAfsRef
            .update({
              addedItemCount: count,
              addedBlocks: blocks
            })
            .then(() => {})
            .catch(err => {
              this.toast.show(err.message);
              reject(err);
            });
        })
        .catch(err => {
          this.toast.show(err.message);

          reject(err);
        });
    });
    return promise;
  }

  getallusers() {
    var promise = new Promise((resolve, reject) => {
      this.firedata
        .orderByChild("uid")
        .once("value", snapshot => {
          let userdata = snapshot.val();
          let temparr = [];
          for (var key in userdata) {
            if (key != firebase.auth().currentUser.uid) {
              temparr.push(userdata[key]);
            }
          }
          resolve(temparr);
        })
        .catch(err => {
          this.toast.show(err.message);

          reject(err);
        });
    });
    return promise;
  }

  getspecificuser(userID) {
    //Restrict Privacy More
    var promise = new Promise((resolve, reject) => {
      //firestore
      this.firestore
        .get(`users/${userID}`)
        .then(ref => {
          let subscription = ref.valueChanges().subscribe((user: User) => {
            resolve(user);
          });
        })
        .catch(err => {
          this.toast.show(err.message);
          reject(err);
        });
    });
    return promise;
  }

  getUserOnlineStatus(userID) {
    var promise = new Promise((resolve, reject) => {
      this.firestore
        .get(`users/${userID}`)
        .then(ref => {
          let subscription = ref.valueChanges().subscribe((user: User) => {
            resolve(user.isOnline);
          });
        })
        .catch(err => {
          this.toast.show(err.message);
          reject(err);
        });
    });
    return promise;
  }

  getUsername(userID) {
    var promise = new Promise((resolve, reject) => {
      this.firestore
        .get(`users/${userID}`)
        .then(ref => {
          let subscription = ref.valueChanges().subscribe((user: User) => {
            resolve(user.displayName);
          });
        })
        .catch(err => {
          this.toast.show(err.message);
          reject(err);
        });
    });
    return promise;
  }

  public getUser(): Promise<any> {
    return new Promise(resolve => {
      this.authSubscription = this.afireauth.authState.subscribe(
        (user: firebase.User) => {
          resolve(user);
        }
      );
    });
  }

  public getMembershipStatus(): Promise<any> {
    return new Promise(resolve => {
      this.authSubscription = this.afireauth.authState.subscribe(
        (user: firebase.User) => {
          let userRef$ = firebase
            .database()
            .ref(`/users/${user.uid}/pro-membership`);
          userRef$.on("value", itemSnapshot => {
            if (itemSnapshot.val() == null) {
              resolve("none");
            } else {
              resolve(itemSnapshot.val());
            }
          });
        }
      );
    });
  }

  public getBlockchain(): Promise<any> {
    return new Promise(resolve => {
      this.authSubscription = this.afireauth.authState.subscribe(
        (user: firebase.User) => {
          if (user.emailVerified) {
            let blocks = [];
            this.blockchainRef = this.database.list(Environment.version);
            this.blockchainRef.valueChanges().subscribe((blocks: any) => {
              blocks = blocks;
              this.storage.set("blocks", blocks);
              this.storage.get("blocks").then(val => {
                if (val.length > blocks.length) {
                  let alert = this.alertCtrl.create({
                    enableBackdropDismiss: false,
                    title: "Blockchain is corrupted!",
                    message:
                      "All blockchain functions have been disabled until blockchain is fixed.",
                    buttons: ["Dismiss"]
                  });
                  alert.present();
                }
                resolve({ blocks: blocks, success: true });
              });
            });
          }
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts